/**
 * Componente: Aviso de borrador sin guardar
 * Se muestra al entrar a editar un diseño que tiene cambios autoguardados
 * más nuevos que la última vez que se guardó de verdad.
 */

import React from 'react';

const AvisoBorradorModal = ({ onRecuperar, onDescartar }) => (
  <div className="modal-overlay">
    <div className="modal-content aviso-borrador-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>Cambios sin guardar</h2>
      </div>

      <div className="modal-body">
        <p>
          Tenés cambios sin guardar de la última vez. ¿Querés recuperarlos o arrancar de la última versión guardada?
        </p>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn-cancelar" onClick={onDescartar}>
          Última versión guardada
        </button>
        <button type="button" className="btn-guardar" onClick={onRecuperar}>
          Recuperar cambios
        </button>
      </div>
    </div>
  </div>
);

export default AvisoBorradorModal;
